/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from 'ng2-translate/src/translate.pipe';
import * as import3 from 'ng2-translate/src/translate.service';
import * as import4 from '../../spinner/spinner.component.ngfactory';
import * as import5 from '../../spinner/spinner.component';
import * as import6 from '../../../html-utils/html.pipe';
import * as import7 from '@angular/platform-browser';
import * as import8 from './loading-spinner.component';
import * as import9 from '../loading.service';
const styles_LoadingSpinnerComponent:any[] = ([] as any[]);
export const RenderType_LoadingSpinnerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_LoadingSpinnerComponent,
  data: {}
}
);
function View_LoadingSpinnerComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'greeting'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'greeting-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['failed']),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'greeting-text-line-1'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'greeting-text-line-2'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import2.TranslatePipe,[
      import3.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'greeting-text';
    const currVal_1:any = ck(v,5,0,(import0.ɵunv(v,3,1,import0.ɵnov(v,4).transform(co.OrchestrationEvents.initialLoadStatus$)) === co.LoadingStatus.FAILED));
    ck(v,3,0,currVal_0,currVal_1);
  },(ck,v) => {
    const currVal_2:any = import0.ɵunv(v,7,0,ck(v,9,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform('woa.message.entry.starting-1'))));
    ck(v,7,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,12,0,ck(v,14,0,import0.ɵnov((<any>v.parent),0),import0.ɵunv(v,12,0,import0.ɵnov(v,13).transform('woa.message.entry.starting-2'))));
    ck(v,12,0,currVal_3);
  });
}
function View_LoadingSpinnerComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',[[
        'class',
        'loading-indicator-quick-spinner'
      ]
    ],(null as any),(null as any),(null as any),import4.View_SpinnerComponent_0,import4.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import5.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
function View_LoadingSpinnerComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),118,':svg:svg',[
      [
        'class',
        'loading-indicator-spinner'
      ]
      ,
      [
        'height',
        '140'
      ]
      ,
      [
        'viewBox',
        '0 0 140 140'
      ]
      ,
      [
        'width',
        '140'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),46,':svg:defs',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,':svg:linearGradient',[
      [
        'gradientTransform',
        'rotate(90)'
      ]
      ,
      [
        'id',
        'loading-spinner-fade-gradient'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:stop',[
      [
        'offset',
        '0'
      ]
      ,
      [
        'stop-color',
        'black'
      ]
      ,
      [
        'stop-opacity',
        '1'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:stop',[
      [
        'offset',
        '1'
      ]
      ,
      [
        'stop-color',
        'black'
      ]
      ,
      [
        'stop-opacity',
        '0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,':svg:mask',[
      [
        'id',
        'loading-spinner-gradient-mask'
      ]
      ,
      [
        'maskUnits',
        'userSpaceOnUse'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'fill',
        'white'
      ]
      ,
      [
        'height',
        '100%'
      ]
      ,
      [
        'width',
        '100%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'fill',
        'url(#loading-spinner-fade-gradient)'
      ]
      ,
      [
        'height',
        '10'
      ]
      ,
      [
        'width',
        '50'
      ]
      ,
      [
        'x',
        '90'
      ]
      ,
      [
        'y',
        '70'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,':svg:g',[
      [
        'fill',
        'black'
      ]
      ,
      [
        'id',
        'loading-spinner-bite'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '5'
      ]
      ,
      [
        'cy',
        '3'
      ]
      ,
      [
        'r',
        '2'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '10'
      ]
      ,
      [
        'cy',
        '2'
      ]
      ,
      [
        'r',
        '3.5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '15'
      ]
      ,
      [
        'cy',
        '2'
      ]
      ,
      [
        'r',
        '3.5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '20'
      ]
      ,
      [
        'cy',
        '3'
      ]
      ,
      [
        'r',
        '2'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '24'
      ]
      ,
      [
        'cy',
        '3'
      ]
      ,
      [
        'r',
        '2'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'height',
        '20'
      ]
      ,
      [
        'width',
        '32'
      ]
      ,
      [
        'x',
        '0'
      ]
      ,
      [
        'y',
        '2'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,':svg:mask',[
      [
        'id',
        'loading-spinner-loading-spinner-bite-1-mask'
      ]
      ,
      [
        'maskUnits',
        'userSpaceOnUse'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'fill',
        'white'
      ]
      ,
      [
        'height',
        '100%'
      ]
      ,
      [
        'width',
        '100%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:use',[
      [
        ':xlink:href',
        '#loading-spinner-bite'
      ]
      ,
      [
        'transform',
        'translate(75, 39) rotate(-75) scale(1.1)'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,':svg:mask',[
      [
        'id',
        'loading-spinner-loading-spinner-bite-2-mask'
      ]
      ,
      [
        'maskUnits',
        'userSpaceOnUse'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'fill',
        'white'
      ]
      ,
      [
        'height',
        '100%'
      ]
      ,
      [
        'width',
        '100%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:use',[
      [
        ':xlink:href',
        '#loading-spinner-bite'
      ]
      ,
      [
        'transform',
        'translate(75, 39) rotate(-75) scale(1.2)'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:use',[
      [
        ':xlink:href',
        '#loading-spinner-bite'
      ]
      ,
      [
        'transform',
        'translate(30, 107) rotate(19) scale(1.8)'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),67,':svg:g',[[
        'transform',
        'rotate(-90, 70, 70)'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateTransform',[
      [
        'attributeName',
        'transform'
      ]
      ,
      [
        'attributeType',
        'XML'
      ]
      ,
      [
        'calcMode',
        'spline'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keySplines',
        '0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.4; 0.8; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'type',
        'rotate'
      ]
      ,
      [
        'values',
        '-90, 70, 70; -685, 70, 70; -685, 70, 70; -810, 70, 70'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),62,':svg:g',[[
        'id',
        'loading-spinner-bite-rocker'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateTransform',[
      [
        'attributeName',
        'transform'
      ]
      ,
      [
        'attributeType',
        'XML'
      ]
      ,
      [
        'calcMode',
        'spline'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keySplines',
        '0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.5; 0.52; 0.54; 0.56; 0.58; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'type',
        'rotate'
      ]
      ,
      [
        'values',
        '0, 110, 75; 0, 110, 75; -5, 110, 75; 0, 110, 75; 5, 110, 75; 0, 110, 75; 0, 110, 75'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,':svg:g',[[
        'id',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animate',[
      [
        'attributeName',
        'mask'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyTimes',
        '0; 0.2; 0.5; 0.54; 0.9; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'values',
        'url(#loading-spinner-gradient-mask); none; url(#loading-spinner-loading-spinner-bite-1-mask); url(#loading-spinner-loading-spinner-bite-2-mask); none; none'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,':svg:circle',[
      [
        'cx',
        '70'
      ]
      ,
      [
        'cy',
        '70'
      ]
      ,
      [
        'fill',
        'none'
      ]
      ,
      [
        'r',
        '45'
      ]
      ,
      [
        'stroke',
        'var(--woa-chewzie-orange)'
      ]
      ,
      [
        'stroke-dasharray',
        '282'
      ]
      ,
      [
        'stroke-width',
        '0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animate',[
      [
        'attributeName',
        'stroke-width'
      ]
      ,
      [
        'calcMode',
        'spline'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keySplines',
        '0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.4; 0.8; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'values',
        '5; 25; 25; 10'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animate',[
      [
        'attributeName',
        'stroke-dashoffset'
      ]
      ,
      [
        'calcMode',
        'spline'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keySplines',
        '0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.4; 0.8; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'values',
        '282; 50; 50; 282'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,':svg:g',[[
        'transform',
        'translate(115, 71)'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:polygon',[
      [
        'fill',
        'var(--woa-chewzie-orange)'
      ]
      ,
      [
        'points',
        '-20,0 0,-18 20,0'
      ]
      ,
      [
        'transform',
        'scale(0)'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateTransform',[
      [
        'attributeName',
        'transform'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyTimes',
        '0; 0.2; 0.4; 0.8; 0.9; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'type',
        'scale'
      ]
      ,
      [
        'values',
        '0; 0; 1; 1; 0; 0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),19,':svg:g',[
      [
        'fill',
        'var(--woa-chewzie-orange)'
      ]
      ,
      [
        'id',
        'crumbs-1'
      ]
      ,
      [
        'transform',
        'translate(80, 20)'
      ]
      ,
      [
        'visibility',
        'hidden'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animate',[
      [
        'attributeName',
        'visibility'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyTimes',
        '0; 0.5; 0.8; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'values',
        'hidden; visible; hidden; hidden'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:circle',[
      [
        'cx',
        '5'
      ]
      ,
      [
        'cy',
        '6'
      ]
      ,
      [
        'r',
        '2.25'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateMotion',[
      [
        'calcMode',
        'linear'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyPoints',
        '0; 0; 1; 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.5; 0.56; 1'
      ]
      ,
      [
        'path',
        'M0,0 L2,1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:circle',[
      [
        'cx',
        '10'
      ]
      ,
      [
        'cy',
        '16'
      ]
      ,
      [
        'r',
        '3.0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateMotion',[
      [
        'calcMode',
        'linear'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyPoints',
        '0; 0; 1; 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.5; 0.56; 1'
      ]
      ,
      [
        'path',
        'M0,0 L2,-2'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '11'
      ]
      ,
      [
        'cy',
        '1'
      ]
      ,
      [
        'r',
        '2.5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '19'
      ]
      ,
      [
        'cy',
        '8'
      ]
      ,
      [
        'r',
        '2.5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '16'
      ]
      ,
      [
        'cy',
        '25'
      ]
      ,
      [
        'r',
        '2.25'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,':svg:g',[
      [
        'fill',
        'var(--woa-chewzie-orange)'
      ]
      ,
      [
        'id',
        'crumbs-2'
      ]
      ,
      [
        'transform',
        'translate(40, 115)'
      ]
      ,
      [
        'visibility',
        'hidden'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animate',[
      [
        'attributeName',
        'visibility'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyTimes',
        '0; 0.54; 0.8; 1'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]
      ,
      [
        'values',
        'hidden; visible; hidden; hidden'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateMotion',[
      [
        'calcMode',
        'linear'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyPoints',
        '0; 0; 1; 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.54; 0.56; 1'
      ]
      ,
      [
        'path',
        'M0,0 L-2,3'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '2'
      ]
      ,
      [
        'cy',
        '2'
      ]
      ,
      [
        'r',
        '2.25'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '13'
      ]
      ,
      [
        'cy',
        '5'
      ]
      ,
      [
        'r',
        '3.0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:circle',[
      [
        'cx',
        '23'
      ]
      ,
      [
        'cy',
        '10'
      ]
      ,
      [
        'r',
        '2.5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,':svg:circle',[
      [
        'cx',
        '16'
      ]
      ,
      [
        'cy',
        '14'
      ]
      ,
      [
        'r',
        '2.25'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:animateMotion',[
      [
        'calcMode',
        'linear'
      ]
      ,
      [
        'dur',
        '3s'
      ]
      ,
      [
        'keyPoints',
        '0; 0; 1; 1'
      ]
      ,
      [
        'keyTimes',
        '0; 0.54; 0.56; 1'
      ]
      ,
      [
        'path',
        'M0,0 L-2,3'
      ]
      ,
      [
        'repeatCount',
        'indefinite'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_LoadingSpinnerComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'loading-indicator-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.loadingService.loadingMessage$));
    ck(v,1,0,currVal_0);
  });
}
function View_LoadingSpinnerComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'loading-indicator'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod([
      'with-quick-spinner',
      'with-message'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_LoadingSpinnerComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_LoadingSpinnerComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_LoadingSpinnerComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'loading-indicator';
    const currVal_1:any = ck(v,4,0,!import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.indicatorVisible$)),(co.showMessages && import0.ɵunv(v,1,1,import0.ɵnov(v,3).transform(co.loadingService.loadingMessage$))));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.indicatorVisible$));
    ck(v,7,0,currVal_2);
    const currVal_3:any = import0.ɵunv(v,11,0,import0.ɵnov(v,12).transform(co.indicatorVisible$));
    ck(v,11,0,currVal_3);
    const currVal_4:any = (co.showMessages && import0.ɵunv(v,15,0,import0.ɵnov(v,16).transform(co.loadingService.loadingMessage$)));
    ck(v,15,0,currVal_4);
  },(null as any));
}
function View_LoadingSpinnerComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'loading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import1.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    import0.ɵpod(['with-indicator']),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_LoadingSpinnerComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'loading';
    const currVal_1:any = ck(v,4,0,(import0.ɵunv(v,1,1,import0.ɵnov(v,2).transform(co.indicatorVisible$)) && (import0.ɵunv(v,1,1,import0.ɵnov(v,3).transform(co.OrchestrationEvents.initialLoadStatus$)) === co.LoadingStatus.LOADED)));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = (import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.OrchestrationEvents.initialLoadStatus$)) === co.LoadingStatus.LOADED);
    ck(v,7,0,currVal_2);
  },(null as any));
}
export function View_LoadingSpinnerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import6.HtmlPipe,[import7.DomSanitizer]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_LoadingSpinnerComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import1.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_LoadingSpinnerComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import8.LoadingSpinnerComponent = v.component;
    const currVal_0:any = (import0.ɵunv(v,2,0,import0.ɵnov(v,3).transform(co.OrchestrationEvents.initialLoadStatus$)) !== co.LoadingStatus.LOADED);
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.loading;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_LoadingSpinnerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-loading-spinner',([] as any[]),(null as any),(null as any),(null as any),View_LoadingSpinnerComponent_0,RenderType_LoadingSpinnerComponent)),
    import0.ɵdid(245760,(null as any),0,import8.LoadingSpinnerComponent,[
      import0.ChangeDetectorRef,
      import9.LoadingService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const LoadingSpinnerComponentNgFactory:import0.ComponentFactory<import8.LoadingSpinnerComponent> = import0.ɵccf('woa-loading-spinner',import8.LoadingSpinnerComponent,View_LoadingSpinnerComponent_Host_0,{showMessages: 'showMessages'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ui-elements/loading/loading-spinner/loading-spinner.component.ngfactory.ts